module.exports = __webpack_public_path__ + "static/media/09.9f789585.png";